import React from 'react'
import { Helmet } from 'react-helmet-async'
import MembershipApplicationHero from '../components/sections/MembershipApplicationHero'
import MembershipApplicationForm from '../components/sections/MembershipApplicationForm'
import MembershipBenefitsOverview from '../components/sections/MembershipBenefitsOverview'
import MembershipProcess from '../components/sections/MembershipProcess'

const ApplyMembershipPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Apply for Membership | FGA Prestige - Exclusive Luxury Access</title>
        <meta name="description" content="Apply for exclusive membership at FGA Prestige and unlock personalized luxury fashion services, priority access, and bespoke styling experiences." />
        <meta name="keywords" content="FGA Prestige membership, luxury fashion membership, exclusive fashion services, personal styling, bespoke shopping, VIP access" />
        <meta property="og:title" content="Apply for Membership | FGA Prestige - Exclusive Luxury Access" />
        <meta property="og:description" content="Apply for exclusive membership at FGA Prestige and unlock personalized luxury fashion services and VIP experiences." />
        <meta property="og:image" content="/images/membership-og.jpg" />
        <meta property="og:url" content="https://fgaprestige.com/apply-membership" />
      </Helmet>
      
      <main className="min-h-screen">
        <MembershipApplicationHero />
        <MembershipProcess />
        <MembershipApplicationForm />
        <MembershipBenefitsOverview />
      </main>
    </>
  )
}

export default ApplyMembershipPage